"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeAnchorFromLink = exports.serializeAnchorAsLink = exports.isValidAnchorId = exports.getHowToCreateAnchorUrl = void 0;

var getHowToCreateAnchorUrl = function getHowToCreateAnchorUrl() {
  return "https://knowledge.hubspot.com/articles/kcs_article/cos-pages-editor/insert-and-manage-anchor-links-to-your-blog-posts-pages-and-knowledge-base-articles";
};

exports.getHowToCreateAnchorUrl = getHowToCreateAnchorUrl;

var isValidAnchorId = function isValidAnchorId(id) {
  // Follows HTML4 rules: https://www.w3.org/TR/html401/types.html#type-id
  return id.length > 0 && /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(id);
};

exports.isValidAnchorId = isValidAnchorId;

var serializeAnchorAsLink = function serializeAnchorAsLink(anchor) {
  return "#" + anchor;
};

exports.serializeAnchorAsLink = serializeAnchorAsLink;

var deserializeAnchorFromLink = function deserializeAnchorFromLink(anchorLink) {
  if (anchorLink.startsWith('#')) {
    return anchorLink.substr(1);
  }

  return anchorLink;
};

exports.deserializeAnchorFromLink = deserializeAnchorFromLink;